import moment from 'moment';

export default class CookieHelper {

  static setCookie(name, value, timeParam = {}) {
    var expiresResult = "";
    if (timeParam["value"] && timeParam["duration"]) {
      var momentDate = moment().add(timeParam.value, timeParam.duration);
      expiresResult = "; expires=" + momentDate.toDate().toUTCString();
    }
    var cookieResult = name + "=" + value + expiresResult;
    document.cookie = cookieResult;
  }

  static readCookie(name) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

}
